import React from "react"
import { styled } from "@mui/material/styles"
import { css } from '@emotion/react';
import ThemeProviderWrapper from "./ThemeProviderWrapper"

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  StyledEngineProvider,
  Snackbar,
} from "@mui/material";
import MuiAlert from '@mui/material/Alert'
import Cookies from "js-cookie"
import { logEvent } from "../utils/analytics"

const SFDialogTitle = styled(DialogTitle)`
  font-size: 34px;
  font-weight: 900;
`
const SFDialogContentText = styled(DialogContentText)`
  font-size: 1.5rem;
  line-height: 41px;
  font-weight: 500;
  color: black;
  margin-bottom: 20px;

  strong {
    text-decoration: underline;
  }
`
const SFDialogActions = styled(DialogActions)`
  padding: 0 24px 16px 24px;
  margin-top: 8px;

  .MuiButtonBase-root {
    font-size: 1.2rem;
  }
`

export default class SignUpOfferDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: props.showModal,
      isSnackbarOpen: props.showModal ? false : true,
      minutesValidFor: props.minutesValidFor,
    }
  }

  componentDidMount() {
    const newIntervalId = setInterval(() => {
      this.setState((prevState) => {
        return {
          ...prevState,
          minutesValidFor: prevState.minutesValidFor - 1,
        }
      })
      if (this.state.minutesValidFor <= 0) {
        this.setState({ isSnackbarOpen: false, isOpen: false })
      }
    }, 60000)

    this.setState((prevState) => {
      return {
        ...prevState,
        intervalId: newIntervalId,
      }
    })
  }

  componentWillUnmount() {
    const { intervalId } = this.state
    clearInterval(intervalId)
  }

  handleClose = () => {
    this.setState({ isOpen: false, isSnackbarOpen: true })
    logEvent("Closed Signup offer modal")
  }

  handleYesClick = () => {
    const { signUpOfferUrl } = this.props
    logEvent("Clicked yes on Signup offer modal")
    window.location.href = signUpOfferUrl
  }

  handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({ isSnackbarOpen: false })
    Cookies.set("dismissedSignUpSnackbar", "true", { expires: 7 })
    logEvent("Dismissed Signup offer Snackbar")
  }

  handleSnackbarLinkClick = () => {
    logEvent("Clicked Signup offer Snackbar link")
  }

  render() {
    const dismissedSignUpSnackbar = Cookies.get("dismissedSignUpSnackbar")
    if (dismissedSignUpSnackbar === "true") {
      return null
    }

    const { signUpOfferUrl } = this.props
    const { isOpen, isSnackbarOpen, minutesValidFor } = this.state

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProviderWrapper>
          <Dialog open={isOpen} onClose={this.handleClose}>
            <SFDialogTitle>
              🙌 Woohoo! You've earned 5 free download credits.
            </SFDialogTitle>
            <DialogContent>
              <SFDialogContentText>
                Not enough credits to keep you in flow?
              </SFDialogContentText>
              <SFDialogContentText>
                You'll love the creative spark that Sample Focus will bring to
                your workflow.

                </SFDialogContentText>
                <SFDialogContentText>
                Skeptical? Checkout what other users have to say about Sample Focus in their testimonials below our pricing plans.
              </SFDialogContentText>
              <SFDialogContentText>As a sign-up bonus, please enjoy this one-time offer to
                get your <strong>first year 25% off.</strong>
              </SFDialogContentText>

              <SFDialogContentText>
                Hurry, this offer is only valid for the next {minutesValidFor}{" "}
                minutes!
              </SFDialogContentText>
            </DialogContent>
            <SFDialogActions>
              <Button color="primary" onClick={this.handleClose}>Let me think about it</Button>
              <Button
                size="large"
                variant="contained"
                onClick={this.handleYesClick}
                color="primary"
              >
                Yes, please!
              </Button>
            </SFDialogActions>
          </Dialog>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={isSnackbarOpen}
            // Disable grow animation
            TransitionProps={{
              appear: false,
            }}
          >
            <MuiAlert
              severity="info"
              onClose={this.handleSnackbarClose}
              icon={<i className="far fa-clock" aria-hidden="true"></i>}
              css={css`
                align-items: center;
                .MuiAlert-icon {
                  margin-right: 12px;
                  font-size: 18px;
                }
              `}
            >
              <a
                css={css`
                  font-weight: bold;
                  color: #2c8de5;
                  cursor: pointer;
                  margin-right: 3px;
                  &:hover {
                    text-decoration: underline;
                  }
                `}
                href={signUpOfferUrl}
                onClick={this.handleSnackbarLinkClick}
              >
                Want 25% off extra download credits?
              </a>
              {"  "}This offer expires in {minutesValidFor} minutes.
            </MuiAlert>
          </Snackbar>
        </ThemeProviderWrapper>
      </StyledEngineProvider>
    );
  }
}
